export default __webpack_public_path__ + "static/media/2021-hidalgo.c8f94801.png";